module.exports = __webpack_public_path__ + "static/GaleriesLafayetteLogo-989f8c6e2455c8289c43ec0b428771ac.svg";